module.exports = __webpack_public_path__ + "static/media/IMG_20181115_170338 - Citizen Datasteward.d433c5a4.jpg";